import { CButton } from "@coreui/react";
import { useEffect, useState } from "react";
import { apiCallSPPost, apiCallSPPut } from "src/_apiConfig/apiCall";
import ToastMessage from "src/_components/ToastMessage";
import {
  addToastError,
  addToastSuccess,
  AlertResponse,
} from "src/_constants/alert.type";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearch,
  SCSelect,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import Badge from "src/views/common/controller/Badge";
import TableDateTimeFromat from "src/views/common/Table/TableDateTimeFromat";

const LotLeftRequestHoList = () => {
  const { authenticated } = Auth();
  const [usersData, setUserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [toasts, setToasts] = useState(AlertResponse);

  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  const [CPopUpLotId, setCPopUpLotId] = useState(0);
  const [CPopUpStatus, setCPopUpStatus] = useState("");

  // adding button loader
  const [ButtonLoader, SetButtonLodaer] = useState(false);

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------
  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext,
    popupLotId,
    popupStatus
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
    setCPopUpLotId(popupLotId);
    setCPopUpStatus(popupStatus);
  };

  // // Your default search model
  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    lotNo: "",
    approvalStatus: "Pending",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    setloading(true);
    resetPageLimit();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getLotLeftRequestListHo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getLotLeftRequestListHo();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      lotNo: search.lotNo.trim(),
      collectionSeason: search.collectionSeason,
      tenderNo: search.tenderNo,
      approvalStatus: search.approvalStatus,
    });
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallSPPost(`LotLeftRequest/List/count`, getdata(), 0).then(
        (res) => {
          if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
        }
      );
    }
  };
  const getLotLeftRequestListHo = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUserData([]);

      await apiCallSPPost("LotLeftRequest/List", getdata(), [])
        .then((res) => {
          if (res.success) {
            setUserData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else {
            setUserData();
            paggingManage(0, false);
            alert(res.message);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };

  const SubmitConfirmationPopUpResponse = async () => {
    //ApproveApiCall(CPopUpId);
    SetButtonLodaer(true);
    const data = JSON.stringify({
      id: CPopUpId,
      insertedBy: authenticated.userId,
      lotId: CPopUpLotId,
      approvalStatus: CPopUpStatus,
      //
    });
    await apiCallSPPut("LotLeftRequest/StatusUpdate", data, 0)
      .then(async (res) => {
        if (res.success) {
          console.log("handleSubmit : ", res);
          addToastSuccess(setToasts, res.message);
          handleConfirmationPopUpModalClose();
          resetPageLimit();
          setIsSearch(true);
        } else {
          addToastError(setToasts, res.message, 0);
        }
      })
      .finally(() => {
        SetButtonLodaer(false);
      });
  };

  let statusManage = (value, key) => {
    console.log("statusManage", value, key);
    return (
      <td className="py-2">
        {value !== null &&
          (value === "Pending" ? (
            <Badge
              key={`pending-span${key}`}
              color={"warning"}
              label={"Pending"}
              className={"badgeFont100"}
            />
          ) : value === "Approved" ? (
            <Badge
              key={`approved-span${key}`}
              color={"success"}
              label={"Approved"}
              className={"badgeFont100"}
            />
          ) : (
            <Badge
              key={`rejected-span${key}`}
              color={"danger"}
              label={"Rejected"}
              className={"badgeFont100"}
            />
          ))}
      </td>
    );
  };
  let scopedSlotsList = {
    insertDateTimeformat: (item, index) => {
      return TableDateTimeFromat(item.insertDateTime);
    },
    approvalDateformat: (item, index) => {
      return TableDateTimeFromat(item.approvalDate);
    },
    approvalStatusFromat: (item, index) => {
      return statusManage(item.approvalStatus, "approval_" + index);
    },
    paymentStatusFromat: (item, index) => {
      return statusManage(item.paymentStatus, "payment_" + index);
    },
    approvalRejectedBtn: (item, index) => {
      // {showbtn(props.isAllowToCCFDeleteTheBidderAgreement,item.fileName.toLowerCase())}
      return (
        <td className="py-2">
          {item.approvalStatus === "Pending" && (
            <>
              <CButton
                variant="outline"
                shape="square"
                size="sm"
                color="success"
                onClick={(e) =>
                  ConfirmationPopupHandler(
                    item.id,
                    -1,
                    "Are you sure you want to Approval?",
                    item.lotId,
                    "Approved"
                  )
                }
              >
                Approval
              </CButton>

              <CButton
                variant="outline"
                shape="square"
                size="sm"
                color="danger"
                className={"ml-2"}
                onClick={(e) =>
                  ConfirmationPopupHandler(
                    item.id,
                    -1,
                    "Are you sure you want to Reject?",
                    item.lotId,
                    "Rejected"
                  )
                }
              >
                Reject
              </CButton>
            </>
          )}
        </td>
      );
    },
  };

  let fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    {
      key: "lotNo",
      _style: { width: "10%" },
      label: "Lot No",
    },
    {
      key: "insertedBy",
      _style: { width: "15%" },
      label: "Request By",
    },
    {
      key: "insertDateTimeformat",
      _style: { width: "10%" },
      label: "Request Date",
    },
    {
      key: "approvedBy",
      _style: { width: "15%" },
      label: "Approved By",
    },
    {
      key: "approvalDateformat",
      _style: { width: "10%" },
      label: "Approval Date",
    },

    {
      key: "approvalStatusFromat",
      _style: { width: "10%" },
      label: "Approval Status",
    },
    {
      key: "paymentStatusFromat",
      _style: { width: "10%" },
      label: "Payment Status",
    },

    {
      key: "approvalRejectedBtn",
      label: <div>Action</div>,
      _style: { width: "10.5%" },
      sorter: false,
      filter: false,
    },
  ];

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUserData([]);
  };
  const statusList = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];
  const SearchExtraControl = (
    <>
      <SCSelect
        labelname="Status"
        name="approvalStatus"
        value={search.approvalStatus}
        onChange={updateSearch}
        items={statusList}
      />
      {/* <SCInput
        label={"Lot No :"}
        name={"lotNo"}
        value={search.lotNo}
        onChange={updateSearch}
      /> */}
    </>
  );
  let additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      //isEmailAddressDisplay={true}
      extraControl={SearchExtraControl}
      isLotNumberDisplay={true}
    />
  );
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CommonList
        items={usersData}
        fields={fields}
        listName="Lot Left Request"
        loading={loading}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        additional={additional}
        id="id"
        scopedSlots={scopedSlotsList}
      />
      <div>
        <ConfirmationPopup
          showModal={CPopUpDisplayConfirmationModal}
          hideModal={handleConfirmationPopUpModalClose}
          confirmModal={SubmitConfirmationPopUpResponse}
          id={CPopUpId}
          index={CPopUpIndex}
          ModalBody={CPopUpBodyText}
          // ModalTitle={CPopUpTitle}
          confirmButtonCss="btn btn-danger"
          ButtonLoader={ButtonLoader}
        />
      </div>
    </>
  );
};
export default LotLeftRequestHoList;
